import { colorSchemeDarkBlue, themeQuartz } from "ag-grid-community";

/**
 * Global AG Grid theme configuration for the entire application
 * This theme will be used by all AG Grid components in the app
 */
const createAgGridTheme = () => {
  return themeQuartz.withPart(colorSchemeDarkBlue).withParams({
    // Custom colors
    backgroundColor: "#ffffff",
    foregroundColor: "#374151", // gray-700
    accentColor: "#3b82f6", // blue-500

    // Typography
    fontSize: "12px",
    fontFamily: "ui-sans-serif, system-ui, sans-serif",

    // Spacing and sizing
    spacing: 12,
    rowHeight: 36,
    headerHeight: 36,

    // Borders and colors
    borderColor: "#F4F4F5",
    headerBackgroundColor: "#FFFFFF",

    // Selection and hover states
    selectedRowBackgroundColor: "#dbeafe", // blue-200
    rowHoverColor: "#f3f4f6", // gray-100

    // Icons
    iconColor: "#6b7280", // gray-500
    iconSize: 14,
  });
};

/**
 * Pre-configured theme instance
 * Import this in your components instead of creating a new theme each time
 */
export const agGridTheme = createAgGridTheme();
